import api from '@/api';
import RestApiModel from '@/services/Api/RestApiModel';

class HandIn extends RestApiModel {
  static getResourceEndpoint() {
    return '/hand-ins';
  }

  /**
   * Download ZIP
   * @param reportId
   * @returns {string}
   */
  static downloadZip(reportId) {
    return `${api.defaults.baseURL}${this.getResourceIdEndpoint(reportId)}/download`;
  }
}

export default HandIn;
